// ---------------- External imports ------------------ //
import { useState } from 'react'
import PropTypes from 'prop-types'
import FileSaver from 'file-saver'
import { withLocalize } from 'react-localize-redux'

// ---------------- Material-UI imports ------------------ //
import { Modal } from '@mui/material'

// ---------------- Internal imports ------------------ //
import DownloadSettingsForm from '../components/DownloadSettingsForm'
import { requestFile } from 'utils/request'

const DownloadSettingsContainer = props => {
  const [open] = useState(true)
  const [submitError, setSubmitError] = useState(null)

  const { hideModal, translate, user } = props
  const userData = user && user.toJS ? user.toJS() : user
  const { isPremium, _id } = userData

  const saveResponseFile = async response => {
    if (!response) {
      throw new Error('Download request failed')
    }

    const blob = await response.blob()
    const fileName = response.headers.get('filename')

    FileSaver.saveAs(blob, fileName)
  }

  const handleSubmit = async data => {
    if (props.isSubmitting) return
    setSubmitError(null)

    const systemId = props.system._id
    let startDate = new Date(data.startDate.toString())
    startDate.setHours(0)
    startDate.setMinutes(0)
    startDate.setSeconds(0)

    let endDate = new Date(data.endDate.toString())
    endDate.setHours(23)
    endDate.setMinutes(59)
    endDate.setSeconds(59)

    const submitData = {
      params: data.params,
      fileType: data.fileType,
      micaname: props.system.name,
      order: Number(data.order),
      interval: data.interval,
      base: props.system.baseStationLocation,
      tz: new window.Intl.DateTimeFormat().resolvedOptions().timeZone,
      CustomerId: _id
    }
    if (!data.weather) delete submitData.base
    try {
      if (data.fileType === 'xlsx') {
        const response = await requestFile(
          `systems/` + systemId + `/` + startDate.toISOString() + `/` + endDate.toISOString(),
          {
            method: 'POST',
            data: {
              ...submitData
            },
            headers: {
              accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'content-type': 'application/json'
            }
          }
        )
        await saveResponseFile(response)
      } else {
        const response = await requestFile(
          `systems/` + systemId + `/` + startDate.toISOString() + `/` + endDate.toISOString(),
          {
            method: 'POST',
            data: {
              ...submitData
            }
          }
        )
        await saveResponseFile(response)
      }

      hideModal()
    } catch (error) {
      setSubmitError(translate('validation.noDataAvailable'))
    }
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={hideModal}
        arial-labelledby='simple-modal-title'
        arial-desccribedby='simple-modal-description'
      >
        {/* MUI v5 Modal attaches a ref to its child, so it must be a DOM node,
            not the withLocalize-wrapped form component. */}
        <div>
          <DownloadSettingsForm
            {...props}
            isPremium={isPremium}
            onSubmit={handleSubmit}
            submitError={submitError}
          />
        </div>
      </Modal>
    </div>
  )
}

DownloadSettingsContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  contentText: PropTypes.string,
  title: PropTypes.string,
  buttonName: PropTypes.string
}

export default withLocalize(DownloadSettingsContainer)
